import useSWRFetcher from "../fetcher";
import useSWR from "swr";
import settings from "../../../../constants/settings";
import { CURRENCY, QuoteItem } from "../../../../reducers/uploadedBoard";

enum QuoteType {
  CUSTOM = "Custom",
  INSTANT = "Instant",
}

export interface QuoteHistoryShipment {
  shipment_id: string;
  ship_date: string | null;
  num_boards: number;
  base_lead_time_days: number;
  lead_time_days: number | null;
}

interface QuoteHistoryRecord {
  datetime_created: string;
  quote_type: QuoteType;
  total: number;
  items: QuoteItem[];
  shipments: QuoteHistoryShipment[];
  currency: CURRENCY;
}

interface QuoteHistoryResponse {
  quotes: QuoteHistoryRecord[];
}

export function quoteHistoryUrl(boardId: string) {
  return `${settings.api_url}/boards/${boardId}/quote-history`;
}

export default function useQuoteHistory(boardId: string) {
  const fetcher = useSWRFetcher<QuoteHistoryResponse>(undefined);

  const { data, mutate } = useSWR<QuoteHistoryResponse>(
    quoteHistoryUrl(boardId),
    fetcher,
  );

  return {
    quoteHistory: data || null,
    refreshQuoteHistory: () => void mutate(),
  };
}
